'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var DayPicker = _interopDefault(require('react-day-picker'));
var luxon = require('luxon');
var TimeKeeper = _interopDefault(require('react-timekeeper'));
var CreatableSelect = _interopDefault(require('react-select/creatable'));
var Select = _interopDefault(require('react-select'));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var primary = "#19C3FC";
var secondary = "#fff";
var _default = "#9DA1A7";
var black = "#4B4B4B";
var disabled = "#9B9B9B";
var buttonsColors = {
  primary: {
    background: primary,
    text: secondary
  },
  secondary: {
    background: secondary,
    text: "#247BC4"
  },
  default: {
    background: _default,
    text: "white"
  }
};
var paginationColors = {
  active: {
    background: primary,
    text: secondary
  },
  default: {
    background: secondary,
    text: _default
  }
};
var colors = {
  primary: primary,
  secondary: secondary,
  default: _default,
  black: black,
  disabled: disabled
};

var theme = _objectSpread2(_objectSpread2({}, colors), {}, {
  button: buttonsColors,
  pagination: paginationColors,
  link: _objectSpread2(_objectSpread2({}, buttonsColors), {}, {
    default: {
      text: _default
    }
  }),
  borderRadius: "10px"
});

var CustomThemeProvider = function CustomThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme$1 = _ref$theme === void 0 ? {} : _ref$theme,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement(styled.ThemeProvider, {
    theme: _objectSpread2(_objectSpread2({}, theme), theme$1)
  }, children);
};

var getColor = function getColor(_ref) {
  var _ref$theme = _ref.theme,
      theme$1 = _ref$theme === void 0 ? theme : _ref$theme,
      color = _ref.color,
      _ref$from = _ref.from;
  _ref$from = _ref$from === void 0 ? {} : _ref$from;
  var element = _ref$from.element,
      prop = _ref$from.prop;

  if (element && prop && typeof theme$1[element][color] !== "undefined") {
    return theme$1[element][color][prop];
  } else if (element && !prop) {
    throw new Error("You have to pass a property named prop if you pass an element");
  } else if (theme$1[color]) {
    return theme$1[color];
  } else {
    return color;
  }
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n\n  cursor: pointer;\n  margin: 0 16px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var IconWrapper = styled__default.span(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "default" : _ref$color;
  return "\n    svg { \n      fill: ".concat(getColor({
    theme: theme,
    color: color
  }), ";\n      width: 25px;\n      height: 25px;\n    }\n  ");
});
IconWrapper.defaultProps = {
  theme: theme
};

var Icon = function Icon(props) {
  var InnerIcon = props.iconSrc,
      color = props.color,
      _props$IconWrapper = props.IconWrapper;
  return /*#__PURE__*/React__default.createElement(IconWrapper, _extends({
    color: color
  }, props), /*#__PURE__*/React__default.createElement(InnerIcon, null));
};

Icon.defaultProps = {
  theme: theme
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var ContentWrapper = styled__default.span(_templateObject$1());

var ContentWithIcon = function ContentWithIcon(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? "start" : _ref$iconPosition,
      _ref$onIconClick = _ref.onIconClick,
      onIconClick = _ref$onIconClick === void 0 ? function () {} : _ref$onIconClick,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "default" : _ref$color,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["icon", "children", "iconPosition", "onIconClick", "color", "theme"]);

  if (!icon) {
    return children;
  }

  var IconStyled = function IconStyled() {
    return /*#__PURE__*/React__default.createElement(Icon, {
      iconSrc: icon,
      onClick: onIconClick,
      color: getColor({
        theme: theme,
        color: color,
        from: {
          element: "button",
          prop: "text"
        }
      })
    });
  };

  return iconPosition === "start" ? /*#__PURE__*/React__default.createElement(ContentWrapper, props, /*#__PURE__*/React__default.createElement(IconStyled, null), " ", children) : /*#__PURE__*/React__default.createElement(ContentWrapper, props, children, " ", /*#__PURE__*/React__default.createElement(IconStyled, null));
};

ContentWithIcon.defaultProps = {
  theme: theme
};

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 16px;\n  cursor: pointer;\n  border: none;\n  text-transform: uppercase;\n  outline: none;\n\n  ", "\n    \n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: white;\n  border: 1px solid ", ";\n  cursor: initial;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  width: 50px;\n  height: 50px;\n  padding: 0;\n  border-radius: 50%;\n\n  span {\n    margin: 0;\n    width: 25px;\n    height: 25px;\n    box-shadow: none;\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var roundedStyle = styled.css(_templateObject$2());
var disabledStyle = styled.css(_templateObject2(), function (_ref) {
  var theme = _ref.theme;
  return theme.disabled;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.disabled;
});
var StyledButton = styled__default.button(_templateObject3(), function (_ref3) {
  var theme = _ref3.theme,
      _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? "default" : _ref3$color;
  return "  \n    background-color: ".concat(getColor({
    theme: theme,
    color: color,
    from: {
      element: "button",
      prop: "background"
    }
  }), ";\n    color: ").concat(getColor({
    theme: theme,
    color: color,
    from: {
      element: "button",
      prop: "text"
    }
  }), ";\n    border-radius: ").concat(theme.borderRadius, ";\n    ");
}, function (_ref4) {
  var rounded = _ref4.rounded;
  return rounded ? roundedStyle : "";
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? disabledStyle : "";
});

var Button = function Button(_ref6) {
  var style = _ref6.style,
      props = _objectWithoutProperties(_ref6, ["style"]);

  return /*#__PURE__*/React__default.createElement(StyledButton, _extends({
    style: style
  }, props), /*#__PURE__*/React__default.createElement(ContentWithIcon, props));
};

StyledButton.defaultProps = {
  theme: theme
};
Button.defaultProps = {
  theme: theme
};

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 10px;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var Label = styled__default.label(_templateObject$3(), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "default" : _ref$color;
  return theme[color];
});

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  font-size: 1.5rem;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  flex-shrink: 0;\n  user-select: none;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  left: 0;\n  width: 100%;\n  cursor: inherit;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  padding: 0;\n  z-index: 1;\n  position: absolute;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  position: relative;\n  margin-top: 10px;\n  margin-bottom: 15px;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var Container = styled__default.div(_templateObject$4());
var CheckboxInput = styled__default.input(_templateObject2$1());
var CheckboxSVG = styled__default.svg(_templateObject3$1(), function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return getColor({
    theme: theme,
    color: color
  });
});
CheckboxSVG.defaultProps = {
  theme: theme
};

var Checkbox = function Checkbox(_ref2) {
  var label = _ref2.label,
      _ref2$Label = _ref2.Label,
      CustomLabel = _ref2$Label === void 0 ? Label : _ref2$Label,
      name = _ref2.name,
      style = _ref2.style,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? "secondary" : _ref2$color,
      props = _objectWithoutProperties(_ref2, ["label", "Label", "name", "style", "color"]);

  return /*#__PURE__*/React__default.createElement(Container, {
    style: style
  }, /*#__PURE__*/React__default.createElement(CheckboxInput, _extends({
    type: "checkbox",
    id: name,
    name: name
  }, props)), /*#__PURE__*/React__default.createElement(CheckboxSVG, {
    focusable: "false",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    onClick: props.onClick,
    color: color
  }, props.checked ? /*#__PURE__*/React__default.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }) : /*#__PURE__*/React__default.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  })), /*#__PURE__*/React__default.createElement(CustomLabel, {
    style: {
      marginLeft: 5,
      marginBottom: 0
    },
    color: color,
    name: name
  }, label));
};

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  font-size: 1.5rem;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  flex-shrink: 0;\n  user-select: none;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  left: 0;\n  width: 100%;\n  cursor: inherit;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  padding: 0;\n  z-index: 1;\n  position: absolute;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  position: relative;\n  margin-top: 10px;\n  margin-bottom: 15px;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var Container$1 = styled__default.div(_templateObject$5());
var RadioButtonInput = styled__default.input(_templateObject2$2());
var RadioButtonSVG = styled__default.svg(_templateObject3$2(), function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return getColor({
    theme: theme,
    color: color
  });
});
RadioButtonSVG.defaultProps = {
  theme: theme
};

var RadioButton = function RadioButton(_ref2) {
  var label = _ref2.label,
      _ref2$Label = _ref2.Label,
      CustomLabel = _ref2$Label === void 0 ? Label : _ref2$Label,
      name = _ref2.name,
      style = _ref2.style,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? "secondary" : _ref2$color,
      props = _objectWithoutProperties(_ref2, ["label", "Label", "name", "style", "color"]);

  return /*#__PURE__*/React__default.createElement(Container$1, {
    style: style
  }, /*#__PURE__*/React__default.createElement(RadioButtonInput, _extends({
    type: "radio",
    id: name,
    name: name
  }, props)), /*#__PURE__*/React__default.createElement(RadioButtonSVG, {
    focusable: "false",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    onClick: props.onClick,
    color: color
  }, props.checked ? /*#__PURE__*/React__default.createElement("path", {
    d: "M12 4C7.584 4 4 7.584 4 12C4 16.416 7.584 20 12 20C16.416 20 20 16.416 20 12C20 7.584 16.416 4 12 4ZM12 18.4C8.464 18.4 5.6 15.536 5.6 12C5.6 8.464 8.464 5.6 12 5.6C15.536 5.6 18.4 8.464 18.4 12C18.4 15.536 15.536 18.4 12 18.4ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
  }) : /*#__PURE__*/React__default.createElement("path", {
    d: "M4 12C4 7.584 7.584 4 12 4C16.416 4 20 7.584 20 12C20 16.416 16.416 20 12 20C7.584 20 4 16.416 4 12ZM5.6 12C5.6 15.536 8.464 18.4 12 18.4C15.536 18.4 18.4 15.536 18.4 12C18.4 8.464 15.536 5.6 12 5.6C8.464 5.6 5.6 8.464 5.6 12Z"
  })), /*#__PURE__*/React__default.createElement(CustomLabel, {
    style: {
      marginLeft: 5,
      marginBottom: 0
    },
    color: color,
    name: name
  }, label));
};

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  border-color: ", ";\n  border: 1px solid ", ";\n  color: #4b4b4b;\n  background-color: transparent;\n\n  ", ";\n\n  margin-bottom: 10px;\n  padding: 10px 20px;\n  border-radius: ", ";\n  outline: none;\n\n  :focus {\n    border-color: ", ";\n  }\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var InputContainer = styled__default.div(_templateObject$6());
var StyledInput = styled__default.input(_templateObject2$3(), function (_ref) {
  var theme = _ref.theme;
  return theme.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.default;
}, function (props) {
  return props.disabled ? "background-color: hsl(0,0%,95%);\n  border-color: hsl(0,0%,90%); \n  border-style: solid;\n  border-width: 1px;\n  color: hsl(0,0%,60%);\n  " : "";
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.primary;
});

var Input = function Input(_ref5) {
  var icon = _ref5.icon,
      iconPosition = _ref5.iconPosition,
      onIconClick = _ref5.onIconClick,
      props = _objectWithoutProperties(_ref5, ["icon", "iconPosition", "onIconClick"]);

  var id = props.id,
      required = props.required,
      _props$label = props.label,
      label = _props$label === void 0 ? props.property : _props$label,
      _props$name = props.name,
      name = _props$name === void 0 ? props.property : _props$name,
      _props$showLabel = props.showLabel,
      showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
      _props$Label = props.Label,
      CustomLabel = _props$Label === void 0 ? Label : _props$Label;
  return /*#__PURE__*/React__default.createElement(InputContainer, null, showLabel && label && /*#__PURE__*/React__default.createElement(CustomLabel, {
    htmlFor: id
  }, "".concat(label).concat(required ? "*" : "")), /*#__PURE__*/React__default.createElement(ContentWithIcon, {
    icon: icon,
    iconPosition: iconPosition,
    onIconClick: onIconClick
  }, /*#__PURE__*/React__default.createElement(StyledInput, _extends({}, props, {
    name: name
  }))));
};

StyledInput.defaultProps = {
  theme: theme,
  step: "any"
};

function useOnClickOutside(ref, handler) {
  React.useEffect(function () {
    var listener = function listener(event) {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return function () {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, // Add ref and handler to effect dependencies
  // It's worth noting that because passed in handler is a new ...
  // ... function on every render that will cause this effect ...
  // ... callback/cleanup to run every render. It's not a big deal ...
  // ... but to optimize you can wrap handler in useCallback before ...
  // ... passing it into this hook.
  [ref, handler]);
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50px;\n  display: flex;\n  justify-content: center;\n  z-index: 50;\n  background-color: white;\n  box-shadow: 0 3px 11px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.15);\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  *:focus {\n    outline: none;\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var Container$2 = styled__default.div(_templateObject$7());
var PickerContainer = styled__default.div(_templateObject2$4());

var Picker = function Picker(_ref) {
  var _ref$Input = _ref.Input,
      CustomInput = _ref$Input === void 0 ? Input : _ref$Input,
      value = _ref.value,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["Input", "value", "readOnly", "children"]);

  var ref = React.useRef();

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showPicker = _useState2[0],
      setShowPicker = _useState2[1];

  useOnClickOutside(ref, function () {
    return setShowPicker(false);
  });
  return /*#__PURE__*/React__default.createElement(Container$2, {
    ref: ref
  }, /*#__PURE__*/React__default.createElement(CustomInput, {
    disabled: readOnly,
    readOnly: true,
    value: value,
    onFocus: function onFocus() {
      return setShowPicker(true);
    }
  }), showPicker && /*#__PURE__*/React__default.createElement(PickerContainer, props, children));
};

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  .DayPicker-Day:not(.DayPicker-Day--disabled) {\n    cursor: pointer;\n  }\n\n  .DayPicker-Day--highlighted {\n    background-color: orange;\n    color: white;\n  }\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var CustomPicker = styled__default(Picker)(_templateObject$8());
var MONTHS = ["Enero", "Febrero", "Marzo", "Abril", "Marzo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
var WEEKDAYS_LONG = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
var WEEKDAYS_SHORT = ["Do", "Lu", "Ma", "Mie", "Jue", "Vie", "Sa"];

var DatePicker = function DatePicker(_ref) {
  var disabledDays = _ref.disabledDays,
      _ref$defaultEmptyValu = _ref.defaultEmptyValue,
      defaultEmptyValue = _ref$defaultEmptyValu === void 0 ? "" : _ref$defaultEmptyValu,
      _ref$defaultEmptyDate = _ref.defaultEmptyDate,
      defaultEmptyDate = _ref$defaultEmptyDate === void 0 ? "" : _ref$defaultEmptyDate,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? new Date() : _ref$value,
      props = _objectWithoutProperties(_ref, ["disabledDays", "defaultEmptyValue", "defaultEmptyDate", "onChange", "value"]);

  var formatDate = function formatDate(date) {
    return luxon.DateTime.fromJSDate(date).toLocaleString();
  };

  var currentDate = formatDate(new Date());
  var modifiers = {
    highlighted: value
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CustomPicker, _extends({}, props, {
    value: defaultEmptyValue !== "" && defaultEmptyDate !== "" && formatDate(value) === defaultEmptyDate || defaultEmptyValue !== "" && defaultEmptyDate === "" && currentDate === formatDate(value) ? defaultEmptyValue : formatDate(value)
  }), /*#__PURE__*/React__default.createElement(DayPicker, {
    locale: "es",
    months: MONTHS,
    weekdaysLong: WEEKDAYS_LONG,
    weekdaysShort: WEEKDAYS_SHORT,
    firstDayOfWeek: 1,
    onDayClick: onChange,
    modifiers: modifiers,
    disabledDays: disabledDays,
    selectedDays: value
  })));
};

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  padding: 10px 15px;\n  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var Card = styled__default.div(_templateObject$9(), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "white" : _ref$color;
  return "  \n  border-radius: ".concat(theme.borderRadius, ";\n  background-color: ").concat(getColor({
    theme: theme,
    color: color,
    from: {
      element: "button",
      prop: "background"
    }
  }), ";\n  ");
});
Card.defaultProps = {
  theme: theme
};

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  padding: 10px 16px;\n  cursor: pointer;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLink = styled__default.a(_templateObject$a(), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "default" : _ref$color;
  return "  \n  color: ".concat(getColor({
    theme: theme,
    color: color,
    from: {
      element: "link",
      prop: "text"
    }
  }), ";\n  ");
});
var Link = /*#__PURE__*/React__default.forwardRef(function (_ref2, ref) {
  var style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ["style"]);

  return /*#__PURE__*/React__default.createElement(StyledLink, _extends({
    ref: ref,
    style: style
  }, props), /*#__PURE__*/React__default.createElement(ContentWithIcon, props));
});
StyledLink.defaultProps = {
  theme: theme
};

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  padding: 10px 0;\n  list-style: none;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var List = styled__default.ul(_templateObject$b(), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "default" : _ref$color;
  return " \n  color:  ".concat(getColor({
    theme: theme,
    color: color
  }), "; \n");
});
List.defaultProps = {
  theme: theme
};

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  span {\n    min-width: 56px;\n    margin: 0;\n    margin-right: 20px;\n  }\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  padding: 10px;\n  display: flex;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var StyledListItem = styled__default.li(_templateObject$c(), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "default" : _ref$color;
  return " \n    color:  ".concat(getColor({
    theme: theme,
    color: color
  }), "; \n  ");
});
var CustomContentWithIcon = styled__default(ContentWithIcon)(_templateObject2$5());

var ListItem = function ListItem(props) {
  return /*#__PURE__*/React__default.createElement(StyledListItem, props, /*#__PURE__*/React__default.createElement(CustomContentWithIcon, props));
};

StyledListItem.defaultProps = {
  theme: theme
};

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-bottom: 10px;\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var Text = styled__default.p(_templateObject$d(), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color;
  return getColor({
    theme: theme,
    color: color
  });
});
Text.defaultProps = {
  theme: theme
};

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  outline: 0;\n  max-width: 500px;\n  margin: 1.75rem auto;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - (1.75rem * 2));\n  position: relative;\n  width: auto;\n  pointer-events: none;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  font-weight: 600;\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  background-color: white;\n  backdrop-filter: blur(10px);\n  opacity: 0.6;\n  z-index: 90;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  z-index: 100;\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var Container$3 = styled__default.div(_templateObject$e());
var Blur = styled__default(Container$3)(_templateObject2$6());
var CustomText = styled__default(Text)(_templateObject3$3());
var ModalVerticalAlign = styled__default.div(_templateObject4());
var ModalContent = styled__default(Card)(_templateObject5());

var Modal = function Modal(_ref) {
  var _ref$Title = _ref.Title,
      CustomTitle = _ref$Title === void 0 ? CustomText : _ref$Title,
      title = _ref.title,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["Title", "title", "children"]);

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Container$3, props, /*#__PURE__*/React__default.createElement(ModalVerticalAlign, null, /*#__PURE__*/React__default.createElement(ModalContent, null, title && /*#__PURE__*/React__default.createElement(CustomTitle, {
    as: "p",
    style: {
      marginBottom: 40
    }
  }, title), children))), /*#__PURE__*/React__default.createElement(Blur, null));
};

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 35px;\n  top: 40px;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  cursor: pointer;\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  height: 64px;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", "\n  padding: 10px;\n  height: calc(100vh - 20px);\n  position: relative;\n  overflow-x: hidden;\n  transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var StyledSidebar = styled__default.div(_templateObject$f(), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "default" : _ref$color,
      open = _ref.open;
  return "  \n  background-color: ".concat(theme.button[color].text, "; \n  width: ").concat(open ? "224px" : "73px", ";\n  ");
});
var Spacer = styled__default.div(_templateObject2$7());
var StyledIcon = styled__default.svg(_templateObject3$4(), function (_ref2) {
  var theme = _ref2.theme,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? "default" : _ref2$color;
  return "  \n    fill: ".concat(getColor({
    theme: theme,
    color: color,
    from: {
      element: "button",
      prop: "background"
    }
  }), "; \n  ");
});
var ToggleIcon = styled__default.span(_templateObject4$1());

var DefaultOpenIcon = function DefaultOpenIcon(props) {
  return /*#__PURE__*/React__default.createElement(StyledIcon, _extends({
    width: "20",
    height: "20"
  }, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5H5V0H0V5ZM7.5 20H12.5V15H7.5V20ZM5 20H0V15H5V20ZM0 12.5H5V7.5H0V12.5ZM12.5 12.5H7.5V7.5H12.5V12.5ZM15 0V5H20V0H15ZM12.5 5H7.5V0H12.5V5ZM15 12.5H20V7.5H15V12.5ZM20 20H15V15H20V20Z"
  }));
};

var DefaultCloseIcon = function DefaultCloseIcon(props) {
  return /*#__PURE__*/React__default.createElement(StyledIcon, _extends({
    width: "25",
    height: "20"
  }, props, {
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.1431V7.85742H24.2857V12.1431H0Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.0001V16.4287H24.2857V20.0001H0Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.28571V0H24.2857V4.28571H0Z"
  }));
};

function Sidebar(props) {
  var children = props.children,
      _props$permanent = props.permanent,
      permanent = _props$permanent === void 0 ? false : _props$permanent,
      _props$defaultOpen = props.defaultOpen,
      defaultOpen = _props$defaultOpen === void 0 ? true : _props$defaultOpen,
      _props$buttonColor = props.buttonColor,
      buttonColor = _props$buttonColor === void 0 ? "default" : _props$buttonColor;

  var _useState = React.useState(defaultOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return /*#__PURE__*/React__default.createElement(StyledSidebar, _extends({}, props, {
    open: open
  }), /*#__PURE__*/React__default.createElement(Spacer, null), !permanent && /*#__PURE__*/React__default.createElement(ToggleIcon, {
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, open ? /*#__PURE__*/React__default.createElement(DefaultOpenIcon, {
    color: buttonColor
  }) : /*#__PURE__*/React__default.createElement(DefaultCloseIcon, {
    color: buttonColor
  })), children);
}

StyledIcon.defaultProps = {
  theme: theme
};
StyledSidebar.defaultProps = {
  theme: theme
};

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 35px;\n  top: 25px;\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  cursor: pointer;\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n  height: 64px;\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  background-color: white;\n  width: 100vw;\n  height: 100vh;\n  position: absolute;\n  z-index: 1;\n  padding-top: 50px;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n  padding: 10px;\n  height: 50px;\n  position: relative;\n  overflow-x: hidden;\n  transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

function Topbar(props) {
  var _props$defaultOpen = props.defaultOpen,
      defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen,
      _props$buttonColor = props.buttonColor,
      buttonColor = _props$buttonColor === void 0 ? "default" : _props$buttonColor,
      _props$topbarChildren = props.topbarChildren,
      topbarChildren = _props$topbarChildren === void 0 ? "" : _props$topbarChildren;

  var _useState = React.useState(defaultOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !open ? /*#__PURE__*/React__default.createElement(StyledTopbar, props, /*#__PURE__*/React__default.createElement(Spacer$1, null), typeof topbarChildren === "function" && topbarChildren(), /*#__PURE__*/React__default.createElement(ToggleIcon$1, {
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/React__default.createElement(DefaultOpenIcon$1, {
    color: buttonColor
  }))) : /*#__PURE__*/React__default.createElement(ChildContainer, null, /*#__PURE__*/React__default.createElement(ToggleIcon$1, {
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/React__default.createElement(DefaultCloseIcon$1, {
    color: buttonColor
  })), props.children(setOpen)));
}

var StyledTopbar = styled__default.div(_templateObject$g(), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "default" : _ref$color,
      open = _ref.open;
  return "  \n  background-color: ".concat(theme.button[color].text, ";  \n  ");
});
var ChildContainer = styled__default.div(_templateObject2$8());
var Spacer$1 = styled__default.div(_templateObject3$5());
var StyledIcon$1 = styled__default.svg(_templateObject4$2(), function (_ref2) {
  var theme = _ref2.theme,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? "default" : _ref2$color;
  return "  \n    fill: ".concat(getColor({
    theme: theme,
    color: color,
    from: {
      element: "button",
      prop: "background"
    }
  }), "; \n  ");
});
var ToggleIcon$1 = styled__default.span(_templateObject5$1());

var DefaultOpenIcon$1 = function DefaultOpenIcon(props) {
  return /*#__PURE__*/React__default.createElement(StyledIcon$1, _extends({
    width: "20",
    height: "20"
  }, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.1431V7.85742H24.2857V12.1431H0Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.0001V16.4287H24.2857V20.0001H0Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.28571V0H24.2857V4.28571H0Z"
  }));
};

var DefaultCloseIcon$1 = function DefaultCloseIcon(props) {
  return /*#__PURE__*/React__default.createElement(StyledIcon$1, _extends({
    width: "25",
    height: "20"
  }, props, {
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10 12.478L2.47799 20L0 17.522L7.52201 10L0 2.47799L2.47799 0L10 7.52201L17.522 0L20 2.47799L12.478 10L20 17.522L17.522 20L10 12.478Z"
  }));
};

StyledIcon$1.defaultProps = {
  theme: theme
};
StyledTopbar.defaultProps = {
  theme: theme
};

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  background-color: white;\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}
var Tab = styled__default(Button)(_templateObject$h());
Tab.defaultProps = {
  theme: theme
};

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 10px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  background: white;\n  :nth-child(even) {\n    background: #edf0f4;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: ", ";\n  text-align: center;\n  padding: 15px 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: ", ";\n  text-align: center;\n  padding-bottom: 15px;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n  cursor: context-menu;\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  fill: #9da1a7;\n  width: 1em;\n  height: 1em;\n  margin-left: 10px;\n  ", ";\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 2px solid\n    ", ";\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n\n  & .sort {\n    cursor: pointer;\n  }\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}
var StyledTable = styled__default.table(_templateObject$i());
var StyledThHead = styled__default.thead(_templateObject2$9(), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "default" : _ref$color;
  return getColor({
    theme: theme,
    color: color
  });
});
StyledThHead.defaultProps = {
  theme: theme
};
var sortArrowSVG = {
  path: function path() {
    return /*#__PURE__*/React__default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.8772 10.5L12.253 18.8758L10.6288 20.5L0.628784 10.5L10.6288 0.5L12.253 2.12421L3.8772 10.5Z"
    });
  }
};
var SortArrow = styled__default.svg(_templateObject3$6(), function (_ref2) {
  var _ref2$arrowDirection = _ref2.arrowDirection,
      arrowDirection = _ref2$arrowDirection === void 0 ? false : _ref2$arrowDirection;
  return arrowDirection === "desc" ? "transform: rotate(90deg);" : "transform: rotate(-90deg);";
});
var StyledTrHead = styled__default.tr(_templateObject4$3());
StyledTrHead.defaultProps = {
  theme: theme
};
var StyledTh = styled__default.th(_templateObject5$2(), function (_ref3) {
  var theme = _ref3.theme,
      _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? "default" : _ref3$color;
  return getColor({
    theme: theme,
    color: color
  });
});
StyledTh.defaultProps = {
  theme: theme
};
var StyledTbody = styled__default.tbody(_templateObject6());
var StyledTd = styled__default.td(_templateObject7(), function (_ref4) {
  var theme = _ref4.theme,
      color = _ref4.color;
  return getColor({
    theme: theme,
    color: color
  });
});
StyledTd.defaultProps = {
  theme: theme
};
var StyledTr = styled__default.tr(_templateObject8());
var SortContainer = styled__default.div(_templateObject9());

var Table = function Table(_ref5) {
  var _ref5$headers = _ref5.headers,
      headers = _ref5$headers === void 0 ? [] : _ref5$headers,
      _ref5$onHeaderClick = _ref5.onHeaderClick,
      onHeaderClick = _ref5$onHeaderClick === void 0 ? function () {} : _ref5$onHeaderClick,
      _ref5$onRowClick = _ref5.onRowClick,
      onRowClick = _ref5$onRowClick === void 0 ? false : _ref5$onRowClick,
      _ref5$renderCustomHea = _ref5.renderCustomHeader,
      renderCustomHeader = _ref5$renderCustomHea === void 0 ? function () {} : _ref5$renderCustomHea,
      _ref5$renderCustomCel = _ref5.renderCustomCell,
      renderCustomCell = _ref5$renderCustomCel === void 0 ? function () {} : _ref5$renderCustomCel,
      _ref5$data = _ref5.data,
      data = _ref5$data === void 0 ? [] : _ref5$data,
      _ref5$emptyTableText = _ref5.emptyTableText,
      emptyTableText = _ref5$emptyTableText === void 0 ? "No hay resultados" : _ref5$emptyTableText,
      _ref5$ThHead = _ref5.ThHead,
      CustomThHead = _ref5$ThHead === void 0 ? StyledThHead : _ref5$ThHead,
      _ref5$TrHead = _ref5.TrHead,
      CustomTrHead = _ref5$TrHead === void 0 ? StyledTrHead : _ref5$TrHead,
      _ref5$Th = _ref5.Th,
      CustomTh = _ref5$Th === void 0 ? StyledTh : _ref5$Th,
      _ref5$Td = _ref5.Td,
      CustomTd = _ref5$Td === void 0 ? StyledTd : _ref5$Td,
      _ref5$Tr = _ref5.Tr,
      CustomTr = _ref5$Tr === void 0 ? StyledTr : _ref5$Tr,
      className = _ref5.className,
      filtersSort = _ref5.filtersSort,
      selectedColumnSort = _ref5.selectedColumnSort;
  return /*#__PURE__*/React__default.createElement(StyledTable, {
    className: className
  }, /*#__PURE__*/React__default.createElement(CustomThHead, null, /*#__PURE__*/React__default.createElement(CustomTrHead, null, headers.map(function (header, key) {
    var _header$tableOptions = header.tableOptions;
    _header$tableOptions = _header$tableOptions === void 0 ? {} : _header$tableOptions;
    var _header$tableOptions$ = _header$tableOptions.isSortable,
        isSortable = _header$tableOptions$ === void 0 ? false : _header$tableOptions$,
        _header$tableOptions$2 = _header$tableOptions.sortProperty,
        sortProperty = _header$tableOptions$2 === void 0 ? "" : _header$tableOptions$2;
    return /*#__PURE__*/React__default.createElement(CustomTh, _extends({}, isSortable ? {
      className: "sort"
    } : {}, {
      key: key,
      onClick: isSortable ? function () {
        return onHeaderClick(header);
      } : function () {}
    }), /*#__PURE__*/React__default.createElement(SortContainer, null, header.name || header.label, isSortable && (selectedColumnSort === header.property || selectedColumnSort === sortProperty) && /*#__PURE__*/React__default.createElement(SortArrow, {
      viewBox: "0 0 13 21",
      arrowDirection: filtersSort
    }, sortArrowSVG.path())));
  }), /*#__PURE__*/React__default.createElement(CustomTh, null, renderCustomHeader()))), /*#__PURE__*/React__default.createElement(StyledTbody, null, data.length > 0 ? data.map(function (dataRow, key) {
    return /*#__PURE__*/React__default.createElement(CustomTr, _extends({
      key: key
    }, onRowClick ? {
      className: "sort"
    } : {}), headers.map(function (header, key) {
      return /*#__PURE__*/React__default.createElement(CustomTd, {
        "data-testid": "table-row-".concat(key),
        key: key,
        onClick: onRowClick ? function () {
          return onRowClick(dataRow);
        } : function () {}
      }, getRowData(header, dataRow));
    }), /*#__PURE__*/React__default.createElement("td", null, renderCustomCell(dataRow, key)));
  }) : /*#__PURE__*/React__default.createElement(CustomTr, null, /*#__PURE__*/React__default.createElement(CustomTd, {
    colSpan: headers.length + 1
  }, emptyTableText))));
};

function getRowData(header, dataRow) {
  return header.tableOptions && typeof header.tableOptions.format === "function" ? header.tableOptions.format(dataRow, dataRow[header.property]) : dataRow[header.property];
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteral(["\n  width: 40%;\n  color: ", ";\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteral(["\n  width: 40%;\n  margin-left: 15px;\n  margin-right: 18px;\n  font-weight: 500;\n  line-height: 21px;\n  color: ", ";\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid #9da1a7;\n  box-sizing: border-box;\n  border-radius: 8px;\n  position: relative;\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\n  background: white;\n  :nth-child(even) {\n    background: #edf0f4;\n  }\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}
var StyledTr$1 = styled__default.tr(_templateObject$j());
var TableCell = styled__default.div(_templateObject2$a());
var TableRow = styled__default(Text)(_templateObject3$7());
var RowHeader = styled__default.span(_templateObject4$4(), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "default" : _ref$color;
  return getColor({
    theme: theme,
    color: color
  });
});
RowHeader.defaultProps = {
  theme: theme
};
var RowText = styled__default.span(_templateObject5$3(), function (_ref2) {
  var theme = _ref2.theme,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? "black" : _ref2$color;
  return getColor({
    theme: theme,
    color: color
  });
});
RowText.defaultProps = {
  theme: theme
};

var ResponsiveTable = function ResponsiveTable(_ref3) {
  var _ref3$headers = _ref3.headers,
      headers = _ref3$headers === void 0 ? [] : _ref3$headers,
      _ref3$renderCustomHea = _ref3.renderCustomHeader,
      _ref3$renderCustomCel = _ref3.renderCustomCell,
      renderCustomCell = _ref3$renderCustomCel === void 0 ? function () {} : _ref3$renderCustomCel,
      _ref3$onRowClick = _ref3.onRowClick,
      onRowClick = _ref3$onRowClick === void 0 ? false : _ref3$onRowClick,
      _ref3$data = _ref3.data,
      data = _ref3$data === void 0 ? [] : _ref3$data,
      _ref3$emptyTableText = _ref3.emptyTableText,
      emptyTableText = _ref3$emptyTableText === void 0 ? "No hay resultados" : _ref3$emptyTableText,
      className = _ref3.className;
  return data.length > 0 ? data.map(function (dataRow, key) {
    return /*#__PURE__*/React__default.createElement(TableCell, {
      key: key,
      className: className,
      onClick: onRowClick ? function () {
        return onRowClick(dataRow);
      } : function () {}
    }, /*#__PURE__*/React__default.createElement(RowText, null, renderCustomCell(dataRow, key)), headers.map(function (header, HKey) {
      return /*#__PURE__*/React__default.createElement(TableRow, {
        key: HKey
      }, /*#__PURE__*/React__default.createElement(RowHeader, null, header.name), /*#__PURE__*/React__default.createElement(RowText, null, dataRow[header.property]));
    }));
  }) : /*#__PURE__*/React__default.createElement(RowText, {
    colSpan: headers.length + 1
  }, emptyTableText);
};

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  text-transform: uppercase;\n  outline: none;\n  padding: 8px;\n  min-width: 32px;\n  border: 1px solid ", ";\n  cursor: pointer;\n  margin: 0 5px;\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}
var StyledPaginationItem = styled__default.button(_templateObject$k(), function (_ref) {
  var theme = _ref.theme,
      activeItem = _ref.activeItem;
  var activeClass = activeItem ? "active" : "default";
  return "  \n  background-color: ".concat(getColor({
    theme: theme,
    color: activeClass,
    from: {
      element: "pagination",
      prop: "background"
    }
  }), ";\n  color: ").concat(getColor({
    theme: theme,
    color: activeClass,
    from: {
      element: "pagination",
      prop: "text"
    }
  }), " ;\n  border-radius: ").concat(theme.borderRadius, ";\n  ");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.default;
});

var PaginationItem = function PaginationItem(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React__default.createElement(StyledPaginationItem, props, children);
};

StyledPaginationItem.defaultProps = {
  theme: theme
};
PaginationItem.defaultProps = {
  theme: theme
};

var breakpoints = {
  MOBILE: 576,
  TABLET: 768,
  DESKTOP: 992,
  RETINA: 1200,
  RETINAM: 1400,
  RETINAL: 1600
};
var mediaQuery = {
  MOBILE: function MOBILE(str, values) {
    return getMediaQuery(breakpoints.MOBILE, joinInterpolations(str, values));
  },
  TABLET: function TABLET(str, values) {
    return getMediaQuery(breakpoints.TABLET, joinInterpolations(str, values));
  },
  DESKTOP: function DESKTOP(str, values) {
    return getMediaQuery(breakpoints.DESKTOP, joinInterpolations(str, values));
  },
  RETINA: function RETINA(str, values) {
    return getMediaQuery(breakpoints.RETINA, joinInterpolations(str, values));
  },
  RETINAM: function RETINAM(str, values) {
    return getMediaQuery(breakpoints.RETINAM, joinInterpolations(str, values));
  },
  RETINAL: function RETINAL(str, values) {
    return getMediaQuery(breakpoints.RETINAL, joinInterpolations(str, values));
  }
};

var joinInterpolations = function joinInterpolations(strings) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  return strings.map(function (str, index) {
    return typeof values[index] !== "undefined" ? str + values[index] : str;
  }).join("");
};

var getMediaQuery = function getMediaQuery(breakpoint, styles) {
  return "@media ".concat(getWidth(breakpoint), " { ").concat(styles, " }");
};

var getWidth = function getWidth(breakpoint) {
  return "(min-width: ".concat(breakpoint, "px)");
};

var useMedia = function useMedia() {
  var queries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof window !== "undefined") {
    var mediaQueryLists = queries.map(function (q) {
      return window.matchMedia(getWidth(q));
    });

    var getValue = function getValue() {
      var index = mediaQueryLists.findIndex(function (mql) {
        return mql.matches;
      });
      return typeof values[index] !== "undefined" ? values[index] : defaultValue;
    };

    var _useState = React.useState(getValue),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    React.useEffect(function () {
      var handler = function handler() {
        return setValue(getValue);
      };

      mediaQueryLists.forEach(function (mql) {
        return mql.addListener(handler);
      });
      return function () {
        return mediaQueryLists.forEach(function (mql) {
          return mql.removeListener(handler);
        });
      };
    }, []);
    return value;
  } else {
    return defaultValue;
  }
};

var responsive = {
  breakpoints: breakpoints,
  mediaQuery: mediaQuery,
  useMedia: useMedia
};

function _templateObject3$8() {
  var data = _taggedTemplateLiteral(["\n  transform: scaleX(-1);\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  fill: #9da1a7;\n  width: 1em;\n  height: 1em;\n  cursor: pointer;\n  ", "\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$l() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-top: 40px;\n  ", "\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}
var PaginationContainer = styled__default.div(_templateObject$l(), function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? "\n      justify-content: space-between;\n  " : "";
});
var ArrowSVG = styled__default.svg(_templateObject2$b(), function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? "\n    border-radius: 10px;\n    padding: 8px;\n    min-width: 25px;\n    border: 1px solid #9B9B9B;\n  " : "";
});
var InertedArrowSVG = styled__default(ArrowSVG)(_templateObject3$8());

var Pagination = function Pagination(_ref3) {
  var _ref3$paginationLengt = _ref3.paginationLength,
      paginationLength = _ref3$paginationLengt === void 0 ? 1 : _ref3$paginationLengt,
      _ref3$pageBound = _ref3.pageBound,
      pageBound = _ref3$pageBound === void 0 ? 3 : _ref3$pageBound,
      _ref3$currentPage = _ref3.currentPage,
      currentPage = _ref3$currentPage === void 0 ? 1 : _ref3$currentPage,
      _ref3$getPageNumber = _ref3.getPageNumber,
      getPageNumber = _ref3$getPageNumber === void 0 ? function () {} : _ref3$getPageNumber,
      props = _objectWithoutProperties(_ref3, ["paginationLength", "pageBound", "currentPage", "getPageNumber"]);

  var _useState = React.useState({
    upperPageBound: pageBound,
    lowerPageBound: 0,
    num: currentPage,
    increment: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var useMedia = responsive.useMedia,
      breakpoints = responsive.breakpoints;
  var isMobile = !useMedia([breakpoints.TABLET], [true], false);

  var btnPrevClick = function btnPrevClick() {
    var newNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var prevNum = newNum !== 0 ? newNum : page.num - 1;

    if (prevNum > page.lowerPageBound + 1) {
      return {
        num: prevNum
      };
    } else if (page.lowerPageBound < 1) {
      return {
        upperPageBound: pageBound,
        lowerPageBound: 0,
        num: 1
      };
    } else {
      return {
        upperPageBound: page.upperPageBound - 1,
        lowerPageBound: page.lowerPageBound - 1,
        num: prevNum
      };
    }
  };

  var btnNextClick = function btnNextClick() {
    var newNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var nextNum = newNum !== 0 ? newNum : page.num + 1;

    if (nextNum < page.upperPageBound) {
      return {
        num: nextNum
      };
    } else if (nextNum >= paginationLength) {
      return {
        upperPageBound: paginationLength,
        lowerPageBound: paginationLength - pageBound,
        num: paginationLength
      };
    } else {
      return {
        upperPageBound: page.upperPageBound + 1,
        lowerPageBound: page.lowerPageBound + 1,
        num: nextNum
      };
    }
  };

  var btnNumberClick = function btnNumberClick(clickedNum) {
    return clickedNum > page.num ? btnNextClick(clickedNum) : btnPrevClick(clickedNum);
  };

  function handleClick(value) {
    var pageNum = paginationArrowButtons(value);
    setPage(function (currState) {
      return _objectSpread2(_objectSpread2({}, currState), pageNum);
    });
    getPageNumber(pageNum.num);
  }

  var paginationArrowButtons = function paginationArrowButtons(pageTypeOrNumber) {
    if (!isNaN(pageTypeOrNumber)) {
      return btnNumberClick(pageTypeOrNumber);
    }

    switch (pageTypeOrNumber) {
      case "first":
        return {
          num: 1,
          upperPageBound: pageBound,
          lowerPageBound: 0
        };

      case "previous":
        return btnPrevClick();

      case "next":
        return btnNextClick();

      case "last":
        return {
          num: paginationLength,
          upperPageBound: paginationLength,
          lowerPageBound: paginationLength - pageBound
        };

      default:
        return null;
    }
  };

  return /*#__PURE__*/React__default.createElement(PaginationContainer, _extends({
    isMobile: isMobile
  }, props), renderArrows(_objectSpread2(_objectSpread2({}, props), {}, {
    pageNum: page.num,
    onClick: function onClick() {
      return handleClick("first");
    },
    direction: "left",
    arrowType: "doubleArrow",
    style: isMobile ? {
      display: "none"
    } : {}
  })), renderArrows(_objectSpread2(_objectSpread2({}, props), {}, {
    pageNum: page.num,
    onClick: function onClick() {
      return handleClick("previous");
    },
    direction: "left",
    isMobile: isMobile
  })), _toConsumableArray(Array(paginationLength).keys()).map(function (pageIndex) {
    var itemPageNumber = pageIndex + 1;
    var activeItem = page.num === itemPageNumber;

    if (itemPageNumber < page.upperPageBound + 1 && itemPageNumber > page.lowerPageBound) {
      return /*#__PURE__*/React__default.createElement(PaginationItem, _extends({
        key: itemPageNumber,
        onClick: function onClick() {
          return handleClick(itemPageNumber);
        }
      }, props, {
        activeItem: activeItem
      }), itemPageNumber);
    }
  }), renderArrows(_objectSpread2(_objectSpread2({}, props), {}, {
    pageNum: page.num,
    onClick: function onClick() {
      return handleClick("next");
    },
    isMobile: isMobile
  })), renderArrows(_objectSpread2(_objectSpread2({}, props), {}, {
    pageNum: page.num,
    onClick: function onClick() {
      return handleClick("last");
    },
    arrowType: "doubleArrow",
    style: isMobile ? {
      display: "none"
    } : {}
  })));
};

var renderArrows = function renderArrows(_ref4) {
  var pageNum = _ref4.pageNum,
      _ref4$hideNavigationA = _ref4.hideNavigationArrows,
      hideNavigationArrows = _ref4$hideNavigationA === void 0 ? false : _ref4$hideNavigationA,
      _ref4$hideNextAndPrev = _ref4.hideNextAndPrevArrowButton,
      _ref4$hideFirstAndLas = _ref4.hideFirstAndLastArrowButton,
      _ref4$direction = _ref4.direction,
      direction = _ref4$direction === void 0 ? "right" : _ref4$direction,
      _ref4$arrowType = _ref4.arrowType,
      arrowType = _ref4$arrowType === void 0 ? "singleArrow" : _ref4$arrowType,
      props = _objectWithoutProperties(_ref4, ["pageNum", "hideNavigationArrows", "hideNextAndPrevArrowButton", "hideFirstAndLastArrowButton", "direction", "arrowType"]);

  var arrowProps = getArrowProps(arrowType);
  return !hideNavigationArrows && /*#__PURE__*/React__default.createElement(DirectionArrowComponent, _extends({
    viewBox: arrowProps.viewBox,
    direction: direction
  }, props), arrowProps.path());
};

var getArrowProps = function getArrowProps() {
  var arrowType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "singleArrow";
  return arrowType === "singleArrow" ? {
    path: function path() {
      return /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.8772 10.5L12.253 18.8758L10.6288 20.5L0.628784 10.5L10.6288 0.5L12.253 2.12421L3.8772 10.5Z"
      });
    },
    viewBox: "0 0 13 21"
  } : {
    path: function path() {
      return /*#__PURE__*/React__default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 17L10.2923 15.2078L3.5845 8.5L10.2923 1.79225L8.5 0L0 8.5L8.5 17ZM16.6288 15.2078L9.92104 8.5L16.6288 1.79225L14.8365 0L6.33654 8.5L14.8365 17L16.6288 15.2078Z"
      });
    },
    viewBox: "0 0 17 17"
  };
};

var DirectionArrowComponent = function DirectionArrowComponent(_ref5) {
  var _ref5$direction = _ref5.direction,
      direction = _ref5$direction === void 0 ? "right" : _ref5$direction,
      props = _objectWithoutProperties(_ref5, ["direction"]);

  return direction === "right" ? /*#__PURE__*/React__default.createElement(InertedArrowSVG, props) : /*#__PURE__*/React__default.createElement(ArrowSVG, props);
};

var Tabs = function Tabs(props) {
  return /*#__PURE__*/React__default.createElement(Card, props);
};

Tabs.defaultProps = {
  theme: theme
};

var TimePicker = function TimePicker(props) {
  return /*#__PURE__*/React__default.createElement(Picker, props, /*#__PURE__*/React__default.createElement(TimeKeeper, props));
};

function _templateObject$m() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}
var InputContainer$1 = styled__default.div(_templateObject$m());

var MultiSelect = function MultiSelect(props) {
  var id = props.id,
      label = props.label,
      _props$showLabel = props.showLabel,
      showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
      _props$Label = props.Label,
      CustomLabel = _props$Label === void 0 ? Label : _props$Label,
      _props$isCreatable = props.isCreatable,
      isCreatable = _props$isCreatable === void 0 ? true : _props$isCreatable;
  return /*#__PURE__*/React__default.createElement(InputContainer$1, null, showLabel && label && /*#__PURE__*/React__default.createElement(CustomLabel, {
    htmlFor: id
  }, label), isCreatable ? /*#__PURE__*/React__default.createElement(CreatableSelect, props) : /*#__PURE__*/React__default.createElement(Select, props));
};

function _templateObject2$c() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  margin-bottom: 10px;\n  padding: 10px 20px;\n  resize: vertical;\n  outline: none;\n  border-radius: ", ";\n\n  :focus {\n    border-color: ", ";\n  }\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}
var InputContainer$2 = styled__default.div(_templateObject$n());
var StyledInput$1 = styled__default.textarea(_templateObject2$c(), function (props) {
  return props.disabled ? "background-color: hsl(0,0%,95%);\n    border-color: hsl(0,0%,90%); \n    border-style: solid;\n    border-width: 1px;\n    color: hsl(0,0%,60%);\n    " : "background-color: transparent;\n      border: 1px solid ".concat(function (_ref) {
    var theme = _ref.theme;
    return theme.default;
  }, ";\n      border-color: ").concat(function (_ref2) {
    var theme = _ref2.theme;
    return theme.default;
  }, ";\n      color: #4b4b4b;");
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.primary;
});

var Input$1 = function Input(props) {
  var id = props.id,
      label = props.label,
      _props$showLabel = props.showLabel,
      showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
      _props$Label = props.Label,
      CustomLabel = _props$Label === void 0 ? Label : _props$Label;
  return /*#__PURE__*/React__default.createElement(InputContainer$2, null, showLabel && label && /*#__PURE__*/React__default.createElement(CustomLabel, {
    htmlFor: id
  }, label), /*#__PURE__*/React__default.createElement(StyledInput$1, props));
};

StyledInput$1.defaultProps = {
  theme: theme
};

function _templateObject2$d() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 10px;\n  background: #ffffff;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);\n  border-radius: 8px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  transition: opacity 0.3s;\n  width: max-content;\n  max-width: 400px;\n  right: 0;\n  visibility: hidden;\n  padding: 15px 20px;\n  color: #4b4b4b;\n\n  ", ":hover & {\n    visibility: visible;\n    opacity: 1;\n  }\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$o() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}
var TooltipContainer = styled__default.div(_templateObject$o());
var TooltipContent = styled__default(Text)(_templateObject2$d(), TooltipContainer);

var Tooltip = function Tooltip(props) {
  var iconSrc = props.iconSrc,
      children = props.children,
      _props$TooltipContain = props.TooltipContainer,
      CustomTooltipContainer = _props$TooltipContain === void 0 ? TooltipContainer : _props$TooltipContain,
      _props$iconProps = props.iconProps,
      iconProps = _props$iconProps === void 0 ? {} : _props$iconProps,
      _props$textProps = props.textProps,
      textProps = _props$textProps === void 0 ? {} : _props$textProps;
  return /*#__PURE__*/React__default.createElement(CustomTooltipContainer, props, /*#__PURE__*/React__default.createElement(Icon, _extends({
    iconSrc: iconSrc
  }, iconProps)), /*#__PURE__*/React__default.createElement(TooltipContent, textProps, children));
};

Tooltip.defaultProps = {
  theme: theme
};

exports.Button = Button;
exports.Card = Card;
exports.Checkbox = Checkbox;
exports.DatePicker = DatePicker;
exports.Input = Input;
exports.Label = Label;
exports.Link = Link;
exports.List = List;
exports.ListItem = ListItem;
exports.Modal = Modal;
exports.MultiSelect = MultiSelect;
exports.Pagination = Pagination;
exports.PaginationItem = PaginationItem;
exports.RadioButton = RadioButton;
exports.ResponsiveTable = ResponsiveTable;
exports.Sidebar = Sidebar;
exports.Tab = Tab;
exports.Table = Table;
exports.Tabs = Tabs;
exports.Td = StyledTd;
exports.Text = Text;
exports.TextArea = Input$1;
exports.Th = StyledTh;
exports.ThHead = StyledThHead;
exports.ThemeProvider = CustomThemeProvider;
exports.TimePicker = TimePicker;
exports.Tooltip = Tooltip;
exports.Topbar = Topbar;
exports.Tr = StyledTr;
exports.TrHead = StyledTrHead;
exports.responsive = responsive;
